// meta.whatsapp is stored E.164 (+55...); wa.me wants digits only.
export const whatsappHref = value => {
  if (!value) return null
  const digits = String(value).replace(/\D/g, '')
  return digits ? `https://wa.me/${digits}` : null
}
